import { Color } from "config/colors";
import styled from "styled-components";

export const ModalBody = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  min-width: 270px;
  width: 1000px;
  height: 1200px;
  max-height: 90vh;
  max-width: 95vw;
  padding: 20px 20px 30px;
  border-radius: 8px;
  background-color: ${Color.White};
  box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.2);
  overflow-y: auto;

  p {
    margin-bottom: 30px;
  }

  .multi-select {
    margin-right: 10px;
  }
`;

export const ChooseWorkersContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const DateContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const ListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;

  .checkbox-component {
    margin-top: 20px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
  align-items: flex-start;
  row-gap: 4px;
`;